
// /**
//  * 图片裁剪
//  * @param url      图片地址
//  * @param height   图片裁剪高度
//  * @param width    图片裁剪宽度
//  * @param mode     裁剪模式   m_fill   m_pad   m_lfit
//  * @param quality  压缩质量
//  */
export const resizePic = ({ url, h, w = 828, mode = 'm_lfit', quality = 100, format = 'jpg' }) => {
  // const process = '?x-oss-process=image/resize,' + mode
  // const picHeight = h ? ',h_' + h : ''
  // const picWidth = w ? ',w_' + w : ''
  // const picQuality = quality ? '/quality,q_' + quality : ''
  // const hasResized = url ? url.match(/(x-oss-process=image)/) : null
  // const picFormat = format ? `/format,${format}` : ''
  // const newUrl = hasResized === null ? url + process + picWidth + picHeight + picQuality + picFormat : url
  return url
}
